<img
    [src]="src"
    [ngClass]="{
        small: size === 'small',
        medium: size === 'medium',
        large: size === 'large',
        'rounded-full': rounded
    }"
/>
